import angular from "angular";
import slugify from "slugify";
import "es6-map/implement";

import "angular-sanitize";
import "angular-animate";
import "angular-scroll";
import "angularjs-datepicker";
import "angular-i18n/da-dk";
import "angular-debounce";
import "angular-cookies";
import "angular-lazy-image";

angular.lowercase = (text) => text.toLowerCase();

const module = angular
    .module("folkeuni", [
        "ngAnimate",
        "ngCookies",
        "rt.debounce",
        "ngSanitize",
        "720kb.datepicker",
        "duScroll",
        "afkl.lazyImage"
    ])
    .config(function () {})
    .filter("employeeSlugify", function () {
        return function (input, employeeId) {
            slugify.extend({
                ø: "oe"
            });
            slugify.extend({
                å: "aa"
            });

            input = input + " " + employeeId || "";

            var out = "";
            out = slugify(input);
            out = out.toLowerCase();

            return out;
        };
    });

export default module;